import React, { useCallback, useState, useEffect } from "react"
import { IoNotifications } from "react-icons/io5";
import { info, secondary, success } from "../../../theme";
import { DashboardCard } from "../DashboardCard";
import { correctDate, correctDateDashboard, setUpConsultation } from "../../../services/generalServices";
import { IStaysReservationProps, themeTypes } from "../../../interfaces";
import { useGlobal } from "../../../hooks/global";
import { useApi } from "../../../hooks/api";
import { ITable, TableList } from "../../../components/TableList";
import { getCheckStatus, getGuestWithAdicionalGuestsBadge, getOrigin, getStatus } from "../../../utils/columnsTables";
import { reservation_status } from "../../../utils/reservation_status";
import { TbRotateClockwise } from "react-icons/tb";
import { FaBook, FaEdit, FaWhatsapp } from "react-icons/fa";
import { MdDelete, MdOutlineEmail } from "react-icons/md";
import { IPermissionsTypes } from "../../../utils/permissions";
import { FiDownload, FiPrinter } from "react-icons/fi";
import { ModalSendEmail } from "../../../components/Modals/ModalSendEmail";
import { ModalSendWpp } from "../../../components/Modals/ModalSendWpp";
import { ModalReservationsNotifications } from "../../../components/Modals/ModalReservationsNotifications";
import { ModalReservations } from "../../../components/Modals/ModalReservations";
import { ContainerPagination } from "../RankingClients/style";
import PaginationCustom from "../../../components/PaginationCustom";
import { ContentOrLoading } from "../../../components/Loadings/ContentOrLoading";
import { checkInStatusMapper } from "../../Reservations";
import { CgCheckO, CgDanger } from "react-icons/cg";
import { useWallet } from "../../../hooks/wallet";

interface IRankingClientsProps {
    minWidth: number
    theme: themeTypes
    maxWidth: string
    range: { from: any, to: any }
}

const initialTable: ITable = {
    data: [],
    columns: [
        {
            attr: "origin",
            name: "Origem",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14, textAlign: "center" },
        },
        {
            attr: "stays_id",
            name: "ID",
            style: { textAlign: "center" },
            styleContent: { fontSize: 16, fontWeight: 600, textAlign: "center" },
        },
        {
            attr: "guest_accommodation",
            name: "Hóspede / Acomodação",
            style: {},
            styleContent: { fontSize: 14, display: 'flex', flex: 1 },
        },
        {
            attr: "reservation_status",
            name: "Status da Reserva",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14 },
        },
        {
            attr: "checkIn",
            name: "Entrada",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14, textAlign: "center" },
        },
        {
            attr: "checkOut",
            name: "Saída",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14, textAlign: "center" },
        },
        {
            attr: "check_in_status",
            name: "Status do Check-in",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14 },
        },
        {
            attr: "check_out_status",
            name: "Checkout",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14 },
        },
        {
            attr: "createdAt",
            name: "Criado em",
            style: { textAlign: "center" },
            styleContent: { fontSize: 14, textAlign: "center" },
        },
    ],
};

export const ReservationsTableList: React.FC<IRankingClientsProps> = (props) => {
    const { minWidth } = props;

    const { user, api } = useApi();
    const { subscription } = useWallet();
    const { theme, paginationLimit, notify, business } = useGlobal();

    const [loading, setLoading] = useState(false);
    const [atualPage, setAtualPage] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [openModalNotification, setOpenModalNotifications] = useState(false);
    const [numberOfPages, setNumberOfPages] = useState<number>(1);
    const [reservationSelected, setReservationSelected] = useState<IStaysReservationProps | null>(null);
    const [table, setTable] = useState<ITable>(initialTable);
    const [selectedCheckInSendEmail, setSelectedCheckInSendEmail] = useState<IStaysReservationProps | null>(null);
    const [selectedCheckInSendWpp, setSelectedCheckInSendWpp] = useState<IStaysReservationProps | null>(null);

    const isHaveGuestPdfPermission = subscription?.plans?.permissions.includes("GUEST_RECORD");
    const isHaveAcessInstructionsPermission = subscription?.plans?.permissions.includes("ACCESS_INSTRUCTIONS");

    const selectReservation = useCallback(
        (accomoddation: IStaysReservationProps) => {
            setReservationSelected({ ...accomoddation });
            setOpenModal(true);
        },
        []
    );

    const handleOpenModalNotification = useCallback(
        (accomoddation: IStaysReservationProps) => {
            setReservationSelected({ ...accomoddation });
            setOpenModalNotifications(true);
        },
        []
    );

    const searchReservations = useCallback(
        async (page, _filters = null) => {
            setAtualPage(page);
            setLoading(true);
            try {
                let url = `/stays-reservations?page=${page}&limit=${paginationLimit}`;

                const result = await api.get(url);
                const new_reservations = result.data.data as IStaysReservationProps[];
                setTable((atual) => {
                    const new_table = { ...atual };

                    new_table.data = [];
                    new_reservations.forEach((reservation) => {
                        const checkInDate = String(reservation.check_in_date).split("T")[0];
                        const checkInTime = String(reservation.check_in_time);
                        const checkIn = correctDateDashboard(
                            new Date(checkInDate + " " + checkInTime)
                        );

                        const checkOutDate = String(reservation.check_out_date).split(
                            "T"
                        )[0];
                        const checkOutTime = String(reservation.check_out_time);
                        const checkOut = correctDateDashboard(
                            new Date(checkOutDate + " " + checkOutTime)
                        );

                        const checkInRealizedDate = String(reservation.correct_realized_check_in)?.split("T")[0];
                        const checkInRealizedTime = String(reservation.correct_realized_check_in)?.split("T")[1]?.split(":").slice(0, 2).join(":");
                        const checkInRealized = checkInRealizedDate !== 'null' ?
                            correctDateDashboard(new Date(checkInRealizedDate + " " + checkInRealizedTime))
                            : null;

                        const checkOutRealizedDate = String(reservation.correct_realized_check_out)?.split("T")[0];
                        const checkOutRealizedTime = String(reservation.correct_realized_check_out)?.split("T")[1]?.split(":").slice(0, 2).join(":");
                        const checkOutRealized = checkOutRealizedDate !== 'null' ?
                            correctDateDashboard(new Date(checkOutRealizedDate + " " + checkOutRealizedTime))
                            : null;


                        const guestPrimary = getGuestWithAdicionalGuestsBadge({ guests: reservation?.guests, accommodation_stays_id: reservation?.accommodation_stays_id_code, theme });

                        new_table.data.push({
                            id: reservation.id,
                            stays_id: reservation?.stays_id,
                            guests: guestPrimary,
                            guest_accommodation: guestPrimary,
                            reservation_status: getStatus({
                                ...reservation_status[reservation.reservation_status],
                                theme,
                            }),
                            check_in_status: getCheckStatus({
                                theme,
                                dateSrt: checkInRealized,
                                ...checkInStatusMapper[reservation.check_in_status],
                            }),
                            check_out_status: getCheckStatus({
                                theme,
                                dateSrt: checkOutRealized,
                                text: reservation?.check_out?.id ? "Confirmado" : "Não confirmado",
                                color: reservation?.check_out?.id ? '52C41A' : info,
                                icon: reservation?.check_out?.id ? <CgCheckO size={16} style={{ marginRight: 3 }} /> : <CgDanger size={16} style={{ marginRight: 3 }} />,
                            }),
                            checkIn,
                            checkOut,
                            origin: getOrigin({ origin: reservation.origin, theme }),
                            createdAt: correctDate(new Date(reservation.createdAt), {
                                no_have_time: true,
                            }),
                            this: reservation,
                        });
                    });

                    return { ...new_table };
                });
                setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
            } catch (err) {
                notify("Erro na busca pelas reservas!", "error");
            }
            setLoading(false);
        },
        [user]
    );

    const openModalNewReservation = useCallback(() => {
        setReservationSelected(null);
        setOpenModal(true);
    }, []);

    const handleAction = (action_id: string) => {
        if (action_id === "new_item") openModalNewReservation();
    };

    const handleRecreateCheckIn = useCallback(
        async (id: string) => {
            setLoading(true);

            try {
                await api.post(`/check-ins/create-new-password/${id}`);
                notify("Check-in recriado com sucesso!", "success");
                searchReservations(1);
            } catch (error: any) {
                notify("Erro ao recriar o check-in!", "error");
            }

            setLoading(false);
        },
        [api]
    );

    const handleUpdateReservation = useCallback(async (id: string) => {
        setLoading(true)

        try {
            await api.post(`/stays-reservations/${id}`)
            notify("Reserva atualizada com sucesso!", "success")
            searchReservations(1);
        } catch (err) {
            notify("Erro ao atualizar a reserva!", "error")
        }

        setLoading(false)
    }, []);

    const confirmRecreateCheckIn = useCallback(
        async (item: any): Promise<void> => {
            const result = window.confirm(
                "Tem certeza que deseja recriar o check-in da reserva " +
                item?.stays_id
            );

            if (result) handleRecreateCheckIn(item.check_in_id as unknown as string);
        },
        [handleRecreateCheckIn]
    );

    const handleConfirmDeleteCheckIn = useCallback(
        async (id: string) => {
            setLoading(true);

            try {
                await api.delete(`/check-ins/${id}`);

                notify("Check-in excluído com sucesso!", "success");

                await searchReservations(1);
            } catch (error: any) {
                const default_message = "Erro ao excluir a check-in!";
                const message = error.response?.data?.detail ?? default_message;
                notify(message, message === default_message ? "error" : "alert");
            }

            setLoading(false);
        },
        [searchReservations]
    );

    const alertDelete = useCallback(
        async (item: any): Promise<void> => {

            const result = window.confirm(
                "Tem certeza que deseja excluir o check-in da reserva " +
                item?.stays_id
            );

            if (result) handleConfirmDeleteCheckIn(item.check_in_id as unknown as string);
        },
        [handleConfirmDeleteCheckIn]
    );

    const listAction = [
        {
            title: "Editar",
            onClick: (reservation: IStaysReservationProps) => selectReservation(reservation),
            icon: <FaEdit color={secondary[theme]} size={20} />,
            disabled: () => false,
        },
        {
            title: "Notificações",
            onClick: (reservation: IStaysReservationProps) => handleOpenModalNotification(reservation),
            icon: <IoNotifications color={secondary[theme]} size={20} />,
            disabled: () => false,
        },
        {
            title: "Abrir reserva na Stays",
            onClick: (item: any) =>
                window.open(
                    `${business?.stays_url}/i/reservation/${item?.stays_id}`,
                    "_blank"
                ),
            icon: <FaBook color={secondary[theme]} size={20} />,
            disabled: () => false,
        },
        {
            title: "Atualizar reserva",
            onClick: (item: any) => handleUpdateReservation(item.id),
            icon: <TbRotateClockwise color={secondary[theme]} size={20} />,
            disabled: () => !user.user_type.permissions.includes('STAYS-RESERVATIONS-UPDATE'),
        },
        {
            title: "Recriar check-in",
            onClick: confirmRecreateCheckIn,
            icon: <TbRotateClockwise color={secondary[theme]} size={20} />,
            disabled: (item: any) => (
                !user.user_type.permissions.includes("STAYS-RESERVATIONS-UPDATE" as IPermissionsTypes)
                || !item?.check_in_id
            ),
        },
        {
            title: "Excluir check-in",
            onClick: (item: any) => alertDelete(item),
            icon: <MdDelete color={secondary[theme]} size={20} />,
            disabled: (item: any) => (
                !user.user_type.permissions.includes("STAYS-RESERVATIONS-CHECK-INS-DELETE" as IPermissionsTypes)
                || !item?.check_in_id
            ),
        },
    ];

    const beforeListAction = [
        {
            title: "Enviar email",
            onClick: (item: any) => setSelectedCheckInSendEmail(item),
            icon: <MdOutlineEmail color={secondary[theme]} size={20} />,
            disabled: () => !user.user_type.permissions.includes("SEND_EMAILS" as IPermissionsTypes) || !isHaveAcessInstructionsPermission,
        },
        {
            title: "Enviar WhatsApp",
            onClick: (item: any) => setSelectedCheckInSendWpp(item),
            icon: <FaWhatsapp color={secondary[theme]} size={20} />,
            disabled: () => !user.user_type.permissions.includes("SEND_WPP" as IPermissionsTypes) || !isHaveAcessInstructionsPermission,
        },
        {
            title: "Ficha dos hóspedes",
            onClick: (item: any) => window.open(`/guest-registration-pdf?reservation-id=${item.id}`, "_blank"),
            icon: <FiPrinter color={secondary[theme]} size={20} />,
            disabled: () => !isHaveGuestPdfPermission,
        }
    ];

    const onSaveReservation = useCallback(() => {
        setOpenModal(false);
        searchReservations(1);
    }, [user]);

    useEffect(() => {
        let isMounted = true;

        const safeSearchReservations = async (page: number, _filters = null) => {
            setAtualPage(page);
            setLoading(true);
            try {
                let url = `/stays-reservations?page=${page}&limit=${paginationLimit}`;
                const result = await api.get(url);
                const new_reservations = result.data.data as IStaysReservationProps[];
                if (!isMounted) return; // <-- só atualiza se montado

                setTable((atual) => {
                    const new_table = { ...atual };

                    new_table.data = [];
                    new_reservations.forEach((reservation) => {
                        const checkInDate = String(reservation.check_in_date).split("T")[0];
                        const checkInTime = String(reservation.check_in_time);
                        const checkIn = correctDateDashboard(
                            new Date(checkInDate + " " + checkInTime)
                        );

                        const checkOutDate = String(reservation.check_out_date).split(
                            "T"
                        )[0];
                        const checkOutTime = String(reservation.check_out_time);
                        const checkOut = correctDateDashboard(
                            new Date(checkOutDate + " " + checkOutTime)
                        );

                        const checkInRealizedDate = String(reservation.correct_realized_check_in)?.split("T")[0];
                        const checkInRealizedTime = String(reservation.correct_realized_check_in)?.split("T")[1]?.split(":").slice(0, 2).join(":");
                        const checkInRealized = checkInRealizedDate !== 'null' ?
                            correctDateDashboard(new Date(checkInRealizedDate + " " + checkInRealizedTime))
                            : null;

                        const checkOutRealizedDate = String(reservation.correct_realized_check_out)?.split("T")[0];
                        const checkOutRealizedTime = String(reservation.correct_realized_check_out)?.split("T")[1]?.split(":").slice(0, 2).join(":");
                        const checkOutRealized = checkOutRealizedDate !== 'null' ?
                            correctDateDashboard(new Date(checkOutRealizedDate + " " + checkOutRealizedTime))
                            : null;


                        const guestPrimary = getGuestWithAdicionalGuestsBadge({ guests: reservation?.guests, accommodation_stays_id: reservation?.accommodation_stays_id_code, theme });

                        new_table.data.push({
                            id: reservation.id,
                            stays_id: reservation?.stays_id,
                            guests: guestPrimary,
                            guest_accommodation: guestPrimary,
                            reservation_status: getStatus({
                                ...reservation_status[reservation.reservation_status],
                                theme,
                            }),
                            check_in_status: getCheckStatus({
                                theme,
                                dateSrt: checkInRealized,
                                ...checkInStatusMapper[reservation.check_in_status],
                            }),
                            check_out_status: getCheckStatus({
                                theme,
                                dateSrt: checkOutRealized,
                                text: reservation?.check_out?.id ? "Confirmado" : "Não confirmado",
                                color: reservation?.check_out?.id ? '52C41A' : info,
                                icon: reservation?.check_out?.id ? <CgCheckO size={16} style={{ marginRight: 3 }} /> : <CgDanger size={16} style={{ marginRight: 3 }} />,
                            }),
                            checkIn,
                            checkOut,
                            origin: getOrigin({ origin: reservation.origin, theme }),
                            createdAt: correctDate(new Date(reservation.createdAt), {
                                no_have_time: true,
                            }),
                            this: reservation,
                        });
                    });

                    return { ...new_table };
                });
                setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
            } catch (err) {
                if (isMounted) notify("Erro na busca pelas reservas!", "error");
            }
            if (isMounted) setLoading(false);
        };

        safeSearchReservations(1);

        return () => {
            isMounted = false;
        };
    }, []);

    const childrenPaginationCustom = (
        <ContainerPagination>
            <PaginationCustom
                page={atualPage}
                pages={numberOfPages}
                disable={loading}
                onChange={(value: any) =>
                    searchReservations(value)
                }
            />
        </ContainerPagination>
    );

    return (
        <DashboardCard minWidth={minWidth} title="Reservas" theme={theme}>
            <ContentOrLoading type="wave" loading={loading} theme={theme}>

                <TableList
                    loading={false}
                    text_loading="Buscando Reservas"
                    text_empty={"Nenhuma reserva encontrada"}
                    moduleName="reservations"
                    table={table}
                    listActions={listAction}
                    beforeListActions={beforeListAction}
                />

                {childrenPaginationCustom}

                {openModal && (
                    <ModalReservations
                        onCancel={() => setOpenModal(false)}
                        onSave={onSaveReservation}
                        openModal={openModal}
                        backgroundVisible={false}
                        defaultId={reservationSelected?.id}
                    />
                )}
                {openModalNotification && (
                    <ModalReservationsNotifications
                        onCancel={() => setOpenModalNotifications(false)}
                        openModal={openModalNotification}
                        backgroundVisible={false}
                        defaultId={reservationSelected?.id}
                    />
                )}

                {selectedCheckInSendWpp?.id && (
                    <ModalSendWpp
                        onCancel={() => setSelectedCheckInSendWpp(null)}
                        onSave={() => setSelectedCheckInSendWpp(null)}
                        openModal={!!selectedCheckInSendWpp?.id}
                        id={selectedCheckInSendWpp?.id as any}
                    />
                )}
                {selectedCheckInSendEmail && (
                    <ModalSendEmail
                        onCancel={() => setSelectedCheckInSendEmail(null)}
                        onSave={() => setSelectedCheckInSendEmail(null)}
                        openModal={!!selectedCheckInSendEmail}
                        id={selectedCheckInSendEmail.id as any}
                    />
                )}
            </ContentOrLoading>
        </DashboardCard>
    )
}